import React, { Component } from 'react';
import { UIView} from 'ui-router-react'; 
import { CSSTransitionGroup } from 'react-transition-group'; 
import Submenu from '../components/Submenu'; 

class PresseContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  privateClass: ''
		}
		this.handlePrivateClass = this.handlePrivateClass.bind(this);
	}
	handlePrivateClass(){
		this.setState({
			privateClass:'public'
		});
	}
	render() {		   
		   return (
				<div>
					<Submenu privateClass={this.state.privateClass}  menuName="presse" menuItems={this.props.resolves.menuItems} />
					<UIView render={(Comp, props) =>
					  <CSSTransitionGroup
						transitionName="example"
						transitionEnterTimeout={250}
						transitionLeaveTimeout={250}>
						<Comp handlePrivateClass={this.handlePrivateClass} {...props} key={props.transition} />
					  </CSSTransitionGroup>
					}/>
				</div>
			)
	   
	}
}
export default PresseContainer;


// WEBPACK FOOTER //
// ./src/containers/PresseContainer.js